import { useLanguage } from "../../../i18n/LanguageContext";

export default function OutlineBlock({ block }) {
  const { language } = useLanguage();

  const items = block.content?.items || [];
  const translatedItems =
    block.translated_content?.items || [];

  const getTranslatedText = (item, index) => {
    if (language === "zh") {
      return item.chinese || null;
    }

    if (language === "es" || language === "ru") {
      return translatedItems[index]?.text || null;
    }

    return null;
  };

  const getTranslatedMarker = (item, index) => {
    if (language === "es" || language === "ru") {
      return translatedItems[index]?.marker || null;
    }

    return null;
  };

  return (
    <div
      style={{
        padding: "18px",
        border: "1px solid #e5e7eb",
        borderRadius: "14px",
        marginBottom: "14px",
        backgroundColor: "#ffffff",
      }}
    >
      {block.title && (
        <h3 style={{ marginTop: 0 }}>
          {block.title}
        </h3>
      )}

      <div style={{ display: "grid", gap: "14px" }}>
        {items.map((item, index) => {
          const translatedText =
            getTranslatedText(item, index);

          const translatedMarker =
            getTranslatedMarker(item, index);

          return (
            <div key={index}>
              {item.marker && (
                <div
                  style={{
                    fontWeight: "700",
                    marginBottom: translatedMarker ? "2px" : "4px",
                  }}
                >
                  {item.marker}
                </div>
              )}

              {translatedMarker && (
                <div
                  style={{
                    color: "#6b7280",
                    fontWeight: "600",
                    marginBottom: "4px",
                    lineHeight: "1.5",
                  }}
                >
                  {translatedMarker}
                </div>
              )}

              {/* Canonical English */}
              <div style={{ lineHeight: "1.6" }}>
                {item.english}
              </div>

              {/* Selected-language learning aid */}
              {translatedText && (
                <div
                  style={{
                    color: "#6b7280",
                    marginTop: "4px",
                    lineHeight: "1.6",
                  }}
                >
                  {translatedText}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}